/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from 'react'
import { FaTimesCircle } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

import { useStateContext } from '../../../state/context'
import { createPatientRadioTest } from '../../../state/actions/doctor.actions'
import { getRadiologyInvestigationCategories, getRadiologyInvestigationTypes } from '../../../state/actions/pharmacist.actions'


const DoctorAddRadiologyTestModal = () => {
    const dispatch = useDispatch();

    const { modals, setModals } = useStateContext()

    const { patient_update } = useSelector(state => state.root)
    const { new_diagnosis } = useSelector(state => state.doctor)
    const { rad_investigation_types, rad_investigation_categories } = useSelector(state => state.pharmacist)
    
    const [formData, setFormData] = useState({
        investigation_type: 0,
        investigation_category: 0,
        diagnosis: new_diagnosis?.pkid,
        patient: patient_update?.user,
        is_local: true
    })
    
    const [configs, setConfigs] = useState({ investigation_categories: [], })

    useEffect(() => {
		dispatch(getRadiologyInvestigationTypes())
		dispatch(getRadiologyInvestigationCategories())
    }, [])

    useEffect(() => {
        console.log(formData.investigation_type);
        if (formData.investigation_type >= 1) {
            setConfigs({
                ...configs,
                investigation_categories: rad_investigation_categories?.filter(cat => cat.investigation_type === parseInt(formData.investigation_type))
            })
        }
    }, [formData.investigation_type])

    const handleChange = (e, name) => {
        setFormData({ ...formData, [name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        dispatch(createPatientRadioTest({ formData, toast, setModals, modals }));
    }

    return (
        <div className="fixed grid h-screen w-full z-10 bg-[#11111180] place-items-center">
            <div className="bg-white w-[500px] rounded px-[30px] py-[20px]">
                <div className="flex flex-col space-y-5">
                    <div className="flex justify-between items-center">
                        <h4 className={`${modals.showDoctorAddRadiologyTestModal ? 'text-dark-green' : 'text-sky-600'} text-[16px] font-medium`}>
                            {modals.showDoctorAddRadiologyTestModal ? 'Add Radiology Test' : 'Upload Radiology Test'}
                        </h4>
                        <FaTimesCircle
                            className='text-dark-yellow cursor-pointer'
                            onClick={() => {
                                modals.showDoctorAddRadiologyTestModal && setModals({ ...modals, showDoctorAddRadiologyTestModal: !modals.showDoctorAddRadiologyTestModal })
                            }}
                            size={20}
                        />
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="space-y-2">
                            <div className="relative">
                                <select
                                    className="appearance-none w-full bg-gray-300 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none "
                                    name="investigation_type"
                                    onChange={(e) => handleChange(e, e.target.name)}
                                >
                                    <option >Test Type</option>
                                    {rad_investigation_types?.map((type) => (
                                        <option
                                            key={`${type.id}`}
                                            value={type.pkid}
                                        >
                                            {type.title}
                                        </option>
                                    ))}
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg
                                        className="fill-current h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                    >
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                </div>
                            </div>

                            <div className="relative">
                                <select
                                    className="appearance-none w-full bg-gray-300 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none "
                                    name="investigation_category"
                                    onChange={(e) => handleChange(e, e.target.name)}
                                >
                                    <option >Category</option>
                                    {configs?.investigation_categories?.map((cat) => (
                                        <option
                                            key={`${cat.id}`}
                                            value={cat.pkid}
                                        >
                                            {cat.title}
                                        </option>
                                    ))}
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg
                                        className="fill-current h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                    >
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className='mt-4'>
                            <button
                                type='submit'
                                className="inline-block w-[175px] px-6 py-2.5 bg-dark-green text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                            >Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default DoctorAddRadiologyTestModal
